





























































































import { defineComponent, ref, useContext, computed, onMounted } from '@nuxtjs/composition-api'
import { formatPrice } from '@/common/utils/numbers'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

import { useCountry } from '~/composables/country/useCountry'
import { usePriceBrick } from '~/composables/price-brick/usePriceBrick'
import { useI18n } from '~/composables/i18n'
import PriceBrickFooter from '~/components/feature/price-brick/PriceBrickFooter.vue'
import { ProductAvailabilityAndPricing } from '~/plugins/pim.client'
import { PriceBrickSkuData } from '~/types/product/productTypes'
import { useVueModal } from '~/composables/ui/useVueModal'

export default defineComponent({
  components: {
    PriceBrickFooter,
    IconFa6SolidXmark,
  },
  props: {
    skuData: {
      type: Array as () => PriceBrickSkuData[],
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productType: {
      type: String,
      required: false,
      default: null,
    },
    includeInventory: {
      type: Boolean,
      default: false,
    },
    customFormulationLabel: {
      type: String,
      required: false,
      default: null,
    },
    isCnDangerousProduct: {
      type: Boolean,
      required: false,
      default: false,
    },
    templateTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['addToBasket', 'oldPriceBrickSkuSelected'],
  setup(props, { emit }) {
    const { $config, $pim } = useContext()
    const { t } = useI18n()
    const modal = useVueModal()

    const { isCN, isBENELUX, isAU, isCA, isNZ, isFR, selectedCountry } = useCountry()
    const { addToBasketButtonText, showPrices, getCustomFormulationPath } = usePriceBrick()

    const skus = computed(() => props.skuData)
    const checkedSku = ref(0)

    const getClpData = ref<ProductAvailabilityAndPricing[]>([])

    const cnDgProductInquiryUrl = computed(
      () =>
        `/learn-and-support/order-support/china-dg-product-inquiry?product_of_interest=${encodeURIComponent(
          props.productId + ' ' + props.productName
        )}&country=CN`
    )

    onMounted(async () => {
      if (props.includeInventory) {
        getClpData.value = await $pim.getProductAvailabilitiesAndPricing(props.productId, selectedCountry.value)
      }
    })

    const onAddToBasket = () => {
      const selectedItem = skus.value[checkedSku.value]
      let trackAsOldPriceBrick = false
      if (!selectedItem) {
        console.error('No item selected when trying to add item to the basket')
        return
      }

      // TODO: needs to be reworked once argocd env vars will be present
      if (isBENELUX.value) {
        window.open(`${$config.vendor.biokeApiHost}/add/${selectedItem.sku}`, '_blank')
      } else if (isFR.value) {
        window.open(
          `${$config.vendor.ozymeApiHost}?product_search%5Bname%5D=${props.productId}&product_search%5Bproperties%5D%5B392%5D%5B%5D=3197`,
          '_blank'
        )
      } else if (isCA.value) {
        window.open(`${$config.vendor.nebCanadaApiHost}?id=${props.productId}`, '_blank')
      } else if (isAU.value) {
        window.open(`${$config.vendor.nebAustraliaApiHost}?query=${props.productId}&country=en-au`, '_blank')
      } else if (isNZ.value) {
        window.open(`${$config.vendor.nebNewZealandApiHost}?query=${props.productId}&country=en-nz`, '_blank')
      } else if (isCN.value) {
        trackAsOldPriceBrick = true
        if (props.isCnDangerousProduct) {
          modal.show('china-dg-modal')
          return
        } else {
          window.location.href =
            window.location.origin +
            '/learn-and-support/order-support/china-product-inquiry?country=cn&product_of_interest=' +
            encodeURIComponent(props.productId + ' ' + props.productName)
        }
      } else {
        trackAsOldPriceBrick = true
        window.location.href =
          window.location.origin +
          `/product/localInformation.jsp?productNo=${props.productId}&skuId=${selectedItem.sku}`
      }
      emit('addToBasket', {
        items: [
          {
            id: props.productId,
            variant: selectedItem.sku,
            quantity: selectedItem.qty,
          },
        ],
        trackAsOldPriceBrick,
      })
    }

    const customFormulationPath = computed(() => getCustomFormulationPath(props.productId, props.productName))

    const onSelectSku = (index: number, sku: string) => {
      checkedSku.value = index
      emit('oldPriceBrickSkuSelected', sku)
    }

    return {
      t,
      formatPrice,
      onAddToBasket,
      skus,
      customFormulationPath,
      addToBasketButtonText,
      showPrices,
      onSelectSku,
      checkedSku,
      getClpData,
      cnDgProductInquiryUrl,
    }
  },
})
